export default function (context, value) {
    context.dispatch('settings/filter_edit', {
        value,
        name: 'osv'
    }, {root: true});
}